import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCityBuildingFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "#262626",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 7H9V22H2V7ZM5.00002 9.40002H4.40002V10V11V11.6H5.00002H6.00002H6.60002V11V10V9.40002H6.00002H5.00002ZM5.00002 13.4H4.40002V14V15V15.6H5.00002H6.00002H6.60002V15V14V13.4H6.00002H5.00002ZM4.40002 17.4H5.00002H6.00002H6.60002V18V19V19.6H6.00002H5.00002H4.40002V19V18V17.4Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22.0001 22H9.6001V2H22.0001V22ZM11.4001 5.40002H12.0001H14.0001H14.6001V6.00002V7.00002V7.60002H14.0001H12.0001H11.4001V7.00002V6.00002V5.40002ZM16.4001 5.40002H17.0001H19.0001H19.6001V6.00002V7.00002V7.60002H19.0001H17.0001H16.4001V7.00002V6.00002V5.40002ZM12.0001 13.4H11.4001V14V15V15.6H12.0001H14.0001H14.6001V15V14V13.4H14.0001H12.0001ZM16.4001 13.4H17.0001H19.0001H19.6001V14V15V15.6H19.0001H17.0001H16.4001V15V14V13.4ZM12.0001 9.40002H11.4001V10V11V11.6H12.0001H14.0001H14.6001V11V10V9.40002H14.0001H12.0001ZM16.4001 9.40002H17.0001H19.0001H19.6001V10V11V11.6H19.0001H17.0001H16.4001V11V10V9.40002ZM12.0001 17.4H11.4001V18V19V19.6H12.0001H14.0001H14.6001V19V18V17.4H14.0001H12.0001ZM16.4001 17.4H17.0001H19.0001H19.6001V18V19V19.6H19.0001H17.0001H16.4001V19V18V17.4Z"
	})]
});
export default SvgCityBuildingFilled;
